export default __webpack_public_path__ + "static/media/logo-holbox.e163c04c.png";